import { CLEAN_REDUCER } from '../../constants/actionTypes';
import { LOG_OUT } from '../auth/actionTypes';
import { CLEAN_INTEGRATIONS, FETCH_INTEGRATION_DEVICES } from './actionTypes';

const initState = {
	list: [],
	count: 0,
	logs: [],
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_INTEGRATION_DEVICES:
			return {
				...state,
				list: action.payload.data,
				count: action.payload.count,
			};
		case CLEAN_REDUCER:
		case CLEAN_INTEGRATIONS:
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
